<template>
  <div class="pageParent">
    <!-- <nav-bar></nav-bar> -->
    <DetailsNav></DetailsNav>
    <head-first-widget
      :name="baseData.name"
      :date="publishDate"
      :desc="baseData.description"
      :logo="logoUrl"
      :logoDesc="logoDesc"
      :itemList="numItems"
      :video="baseData.pVideoUrl"
      :nameImg="nameImg"
    ></head-first-widget>
    <plat-display-widge
      :title="platDisplayTitle"
      :subTitle="platDisplaySubTitle"
      :items="platDisplayImgs"
    ></plat-display-widge>
    <flow-widget
      :flowData="flowData"
      :baseHeight="baseHeight"
      :localItemIndex="localItemIndex"
      class="web_scroll"
    ></flow-widget>
    <div class="divOffsetParent">
      <project-advantage-widge :data="projectAdvantageData">
      </project-advantage-widge>

      <technology-widge
        :title="technologyTitle"
        :subTitle="technologySubTitle"
        :bgUrl="technologyBgUrl"
        :bg="technologyBg"
      ></technology-widge>
      <course-widge
        :datas="courseDatas"
        :title="courseTitle"
        :subTitle="courseSubTitle"
      ></course-widge>
      <teacher-display-widge
        :title="teacherTitle"
        :subTitle="teacherSubtitle"
        :items="teacherDetails"
      ></teacher-display-widge>
    </div>
    <bottom-widge></bottom-widge>
  </div>
</template>
<script>
// import navBar from "./../../../components/navBar";
import DetailsNav from "./../../../components/detailsNav.vue";
import headFirstWidget from "./../ai/components/headFirstWidget";
import platDisplayWidge from "./../ai/components/platDisplayWidge";
import flowWidget from "./../ai/components/flowWidget";
import projectAdvantageWidge from "./components/projectAdvantageWidge";
import technologyWidge from "./../ai/components/technologyWidge";
import courseWidge from "./../ai/components/courseWidge";
import teacherDisplayWidge from "./../ai/components/teacherDisplayWidge";
import bottomWidge from "./../../../components/bottomWidge";
import { Content } from "../../../../gqlapi/ContentDetail.js";
import { pushArr, courseDataToArr } from "./../../../js/tools";
export default {
  components: {
    // navBar,
    DetailsNav,
    headFirstWidget,
    platDisplayWidge,
    projectAdvantageWidge,
    technologyWidge,
    courseWidge,
    teacherDisplayWidge,
    bottomWidge,
    flowWidget,
  },
  data() {
    return {
      baseData: {},
      logoUrl: "",
      logoDesc: "",
      numItems: [],
      publishDate: "",
      nameImg: "",
      platDisplayTitle: "",
      platDisplaySubTitle: "",
      platDisplayImgs: [],
      flowData: [],
      baseHeight: 1000,
      localItemIndex: 0,
      projectAdvantageData: [],
      technologyTitle: "",
      technologySubTitle: "",
      technologyBgUrl: "",
      technologyBg: "",
      courseTitle: "",
      courseSubTitle: "",
      courseDatas: [],
      courseBg: "",
      teacherTitle: "",
      teacherSubtitle: "",
      teacherBg: "",
      teacherDetails: [],
      oldHeight: 0,
      scrollClass: {
        pInit: "parent web_scroll",
        pChange: "parent web_scroll  p-change",
        cInit: "ul-init",
        cChange: "",
      },
      scrollFlag: {
        top: true,
        bottom: true,
      },
    };
  },
  created() {
    this.getData();
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    Object.freeze(this.scrollFlag);
    Object.freeze(this.scrollClass);
    Object.freeze(this.oldHeight);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let oldHeight = this.oldHeight;
      let localHeight =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      let scrollHeight = this.baseHeight;
      let eles = document.querySelector(".divOffsetParent").children;
      for (let index in eles) {
        if (localHeight > eles[index].offsetTop + scrollHeight-10) {
          this.localItemIndex = parseInt(index, 10);
        }
      }
      let scrollFlag = this.scrollFlag;
      let scrollClass = this.scrollClass;
      if (oldHeight > localHeight) {
        //向上
        if (scrollFlag.top && localHeight < scrollHeight) {
          scrollFlag.top = false;
          scrollFlag.bottom = true;
          let parent = document.querySelector(".web_scroll");
          let child = parent.children[0];
          parent.className = scrollClass.pInit;
          child.className = scrollClass.cInit;
        }
      } else {
        //向下
        if (scrollFlag.bottom && localHeight > scrollHeight) {
          scrollFlag.top = true;
          scrollFlag.bottom = false;
          let parent = document.querySelector(".web_scroll");
          let child = parent.children[0];
          parent.className = scrollClass.pChange;
          child.className = scrollClass.cChange;
        }
      }
      this.oldHeight = localHeight;
    },
    getData() {
        this.$axios.post('/api',{
            operationName: "Content",
            variables:{
              id: sessionStorage.getItem("detailsId"),
            },
            query: Content
        })
        .then((res) => {
          this.baseData = res.data.data.pContent;
          this.getHeadFirstWidgeData();
          this.getplatDisplayWidgeData();
          this.getFlowData();
          this.getTechnologyData();
          this.getCourseWidgeData();
          this.getTeacherDisplayWidgeData();
          this.getProjectAdvantageData();
          this.getBaseHeight();
        });
    },
    getProjectAdvantageData() {
      let baseData = this.baseData;
      this.projectAdvantageData = baseData.detailsList.filter(
        (item) => item.navTitle === "项目优势"
      );
    },
    getBaseHeight() {
      // this.$nextTick(() => {
      //   this.baseHeight = document.querySelector(".divOffsetParent").offsetTop;
      //   console.log("baseHeight:", this.baseHeight);
      // });
      setTimeout(() => {
        this.baseHeight = document.querySelector(".divOffsetParent").offsetTop;
      }, 1000);
    },
    getplatDisplayWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[0];
      if (!data) {
        return;
      }
      this.platDisplayTitle = data.title;
      this.platDisplaySubTitle = data.subTitle;
      let lieBiao = data.lieBiao ? data.lieBiao : [];
      let imgs = [];
      for (let item of lieBiao) {
        if (item.image && item.image.url) {
          imgs.push(item.image.url);
        }
      }
      this.platDisplayImgs = imgs;
    },
    getTeacherDisplayWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[7];
      if (!data) {
        return;
      }
      this.teacherTitle = data.title;
      this.teacherSubtitle = data.subTitle;
      let teacherDetails = [];
      let lieBiao = data.lieBiao ? data.lieBiao : [];
      for (let item of lieBiao) {
        teacherDetails.push({
          name: item.title,
          quarters: item.subTitle,
          headerImage: item.image,
          details: item.description,
        });
      }
      this.teacherDetails = teacherDetails;
    },
    getCourseWidgeData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[6];
      if (!data) {
        return;
      }
      this.courseTitle = data.title;
      this.courseSubTitle = data.subTitle;
      let tuWen = data.tuWen ? data.tuWen : {};
      this.courseBg = tuWen.textBgImage ? tuWen.textBgImage.url : "";
      let arr = [];
      courseDataToArr(
        baseData.courseOutlineTitle1,
        baseData.courseOutlineDesc1,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle2,
        baseData.courseOutlineDesc2,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle3,
        baseData.courseOutlineDesc3,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle4,
        baseData.courseOutlineDesc4,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle5,
        baseData.courseOutlineDesc5,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle6,
        baseData.courseOutlineDesc6,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle7,
        baseData.courseOutlineDesc7,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle8,
        baseData.courseOutlineDesc8,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle9,
        baseData.courseOutlineDesc9,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle10,
        baseData.courseOutlineDesc10,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle11,
        baseData.courseOutlineDesc11,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle12,
        baseData.courseOutlineDesc12,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle13,
        baseData.courseOutlineDesc13,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle14,
        baseData.courseOutlineDesc14,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle15,
        baseData.courseOutlineDesc15,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle16,
        baseData.courseOutlineDesc16,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle17,
        baseData.courseOutlineDesc17,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle18,
        baseData.courseOutlineDesc18,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle19,
        baseData.courseOutlineDesc19,
        arr
      );
      courseDataToArr(
        baseData.courseOutlineTitle20,
        baseData.courseOutlineDesc20,
        arr
      );
      this.courseDatas = arr;
    },
    getTechnologyData() {
      let baseData = this.baseData;
      let data = baseData.detailsList[5];
      if (!data) {
        return;
      }
      this.technologyTitle = data.title;
      this.technologySubTitle = data.subTitle;
      let tuWen = data.tuWen ? data.tuWen : {};
      this.technologyBgUrl = tuWen.image ? tuWen.image.url : "";
      this.technologyBg = tuWen.bgImage ? tuWen.bgImage.url : "";
    },
    getFlowData() {
      let detailsList = this.baseData.detailsList;
      let arr = [];
      let set = new Set();
      detailsList.forEach(item => {
        set.add(item.navTitle);
      });
      arr = [...set];
      arr.shift();
      let arr1 = [];
      arr.forEach((item,index) => {
        arr1.push({
          index:index,
          desc:item
        });
      });
      this.flowData = arr1;
    },
    getHeadFirstWidgeData() {
      let baseData = this.baseData;
      this.logoUrl = baseData.trade
        ? baseData.trade.iconFile
          ? baseData.trade.iconFile.url
          : ""
        : "";
      this.logoDesc = baseData.trade ? baseData.trade.name : "";
      this.publishDate = baseData.lastUpdate;
      let numItems = [];
      pushArr(baseData.baseInfoTitle1, numItems);
      pushArr(baseData.baseInfoTitle2, numItems);
      pushArr(baseData.baseInfoTitle3, numItems);
      pushArr(baseData.baseInfoTitle4, numItems);
      pushArr(baseData.baseInfoTitle5, numItems);
      pushArr(baseData.baseInfoTitle6, numItems);
      this.numItems = numItems;
      this.nameImg = baseData.titleImage ? baseData.titleImage.url : "";
    },
  },
};
</script>
<style>
.div-swiper-teacher .swiper-container .swiper-wrapper .swiper-slide .divImg img{
  width: auto;
  height: 220px;
}
.div-swiper-teacher .swiper-container .swiper-wrapper .swiper-slide .divImg .divDesc{
  height: 240px;
  overflow: hidden;
}
</style>
<style lang="scss" scoped>
@import "./scss/index.scss";
</style>
